<template>
    <pendo-input
        class="string-input"
        :class="`${field}-string-input`"
        :placeholder="localizedPlaceholder"
        :disabled="readOnly"
        :value="value"
        width="200px"
        debounce
        @input="onInputChange" />
</template>

<script>
import { PendoInput } from '@pendo/components';
import isString from 'lodash/isString';

export default {
    name: 'StringInput',
    components: {
        PendoInput,
    },
    props: {
        value: {
            type: null,
            default: null,
        },
        field: {
            type: String,
            default: 'value',
        },
        placeholder: {
            type: String,
            default: '',
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    data () {
        return {
            localizedPlaceholder: '',
        };
    },
    created () {
        this.localizedPlaceholder = !this.placeholder ? this.$t('stringInput.Type value here') : this.placeholder;
        const value = isString(this.value) ? this.value : '';
        this.onInputChange(value);
    },
    methods: {
        // use change event to emit update on blur of input instead of every single keystroke
        onInputChange (value) {
            this.$emit('input', { field: this.field, value });
        },
    },
};
</script>
